import storage from './storage';
import { analisarDestino } from './acesso-rota';

const VALIDADE_EM_MINUTOS = 30;

function expirado(destino) {
  if (!destino || !destino.em) return true;

  return (Date.now() - destino.em) > (VALIDADE_EM_MINUTOS * 60 * 1000);
}

function exigeAutenticacao(rota) {
  return !!(rota && rota.matched && rota.matched.some(registro => registro.meta && registro.meta.auth));
}

export function guardarDestino(rota) {
  if (!rota || !rota.fullPath) return;
  if (!exigeAutenticacao(rota)) return;
  if (rota.fullPath === '/' || rota.name === 'home') return;

  storage.destinoPosLogin({ caminho: rota.fullPath, em: Date.now() });
}

export function limparDestino() {
  storage.destinoPosLogin(null);
}

export function consumirDestino(router) {
  const destino = storage.destinoPosLogin();

  limparDestino();

  if (expirado(destino)) return { caminho: null, negado: false, analise: null };

  const analise = analisarDestino(router, destino.caminho, storage.usuario(), storage.configuracao());

  return { caminho: analise.permitido ? destino.caminho : null, negado: !analise.permitido, analise: analise };
}

export default {
  methods: {
    irParaDestinoPosLogin(rotaPadrao) {
      const destino = consumirDestino(this.$router);

      if (destino.negado) {
        if (window.console && console.warn) {
          console.warn('Redirecionamento pós-login negado:', destino.analise);
        }

        if (window.toastr && destino.analise && destino.analise.exigeAuth) {
          window.toastr.warning('O endereço acessado não está disponível para este usuário.');
        }
      }

      this.$router.push(destino.caminho || rotaPadrao);
    },
    descartarDestinoPosLogin() {
      limparDestino();
    }
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/js/destino-pos-login.js